const API = process.env.REACT_APP_API_URL;

function authHeader(token) {
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

async function parseJson(response) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data?.message || 'Request failed';
    const error = new Error(message);
    error.code = data?.code || 'ERR_INTERNAL';
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export async function getReferralSummary(remoteId, token) {
  const response = await fetch(`${API}/api/referral/summary?remote_id=${remoteId}`, {
    method: 'GET',
    headers: authHeader(token),
  });

  return parseJson(response);
}

export async function getLegacyReferralSummary(remoteId, token) {
  const response = await fetch(`${API}/api/user/show?remote_id=${remoteId}`, {
    method: 'GET',
    headers: authHeader(token),
  });

  const data = await parseJson(response);

  return {
    success: true,
    data: {
      referral_code: data?.referral_code || '',
      referral_url: data?.referral_code
        ? `${window.location.origin}/referral_code?referral_code=${data.referral_code}`
        : '',
      active_downlines: Number(data?.active_downlines || 0),
      required_deposit: Number(data?.required_deposit || 0),
      required_turnover: Number(data?.required_turnover || 0),
      lifetime_cash_rewards: Number(data?.lifetime_cash_rewards || data?.cash_bonus || 0),
      cash_rewards: Number(data?.cash_rewards || data?.cash_bonus || 0),
      referral_turnover: Number(data?.referral_turnover || 0),
      referral_points: Number(data?.referral_points || 0),
      min_convert_points: Number(data?.min_convert_points || 10),
      convert_rate: Number(data?.convert_rate || 1),
    },
  };
}

export async function getReferralRewardHistory(remoteId, token, page = 1, limit = 10) {
  const response = await fetch(`${API}/api/referral/reward-history?remote_id=${remoteId}&page=${page}&limit=${limit}`, {
    method: 'GET',
    headers: authHeader(token),
  });

  return parseJson(response);
}

export async function getReferralConversionHistory(remoteId, token, page = 1, limit = 10) {
  const response = await fetch(`${API}/api/referral/conversion-history?remote_id=${remoteId}&page=${page}&limit=${limit}`, {
    method: 'GET',
    headers: authHeader(token),
  });

  return parseJson(response);
}

export async function claimAllReferralRewards(remoteId, token) {
  try {
    const response = await fetch(`${API}/api/referral/claim-all`, {
      method: 'POST',
      headers: authHeader(token),
      body: JSON.stringify({ remote_id: remoteId }),
    });

    return await parseJson(response);
  } catch (error) {
    if (error?.status !== 404) {
      throw error;
    }

    const legacyResponse = await fetch(`${API}/api/cash-claim`, {
      method: 'POST',
      headers: authHeader(token),
      body: JSON.stringify({}),
    });

    return parseJson(legacyResponse);
  }
}

export async function convertReferralPoints(remoteId, referralPoints, token) {
  const response = await fetch(`${API}/api/referral/convert`, {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ remote_id: remoteId, referral_points: referralPoints }),
  });

  return parseJson(response);
}
